var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 123,
    viewBox: "0 0 115 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6213_23132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7109 103.219L33.1184 81.8594L36.5088 85.5888L48.7142 94.4038L28.7109 103.219Z",
    fill: "#AEB4BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0132 54.0579C91.0132 75.911 74.6207 93.1159 55.0066 93.1159C35.3925 93.1159 19 75.911 19 54.0579C19 32.2049 35.3925 15 55.0066 15C74.6207 15 91.0132 32.2049 91.0132 54.0579Z",
    stroke: "#B3B8C2",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_6213_23132)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.0769,
    cy: 54.0579,
    rx: 40.0066,
    ry: 43.0579,
    fill: "#51936B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.0835 54.0579C94.0835 75.4292 78.0708 92.1159 59.0769 92.1159C40.083 92.1159 24.0703 75.4292 24.0703 54.0579C24.0703 32.6867 40.083 16 59.0769 16C78.0708 16 94.0835 32.6867 94.0835 54.0579Z",
    stroke: "#F5F5F5",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6213_23132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9086 71.6747C53.8968 71.702 39.468 56.8824 39.4883 37.7556C39.4883 36.5065 40.486 35.4883 41.7167 35.4883H47.5982C48.7025 35.4883 49.6407 36.3118 49.8028 37.4205C50.1915 40.0776 50.9537 42.6644 52.0664 45.1019L52.2954 45.6035C52.6138 46.301 52.398 47.1298 51.7816 47.5765C49.9602 48.8967 49.2641 51.554 50.683 53.6275C52.4637 56.2295 54.7083 58.5071 57.2715 60.3136C59.3143 61.7533 61.9322 61.0469 63.2329 59.1986C63.6734 58.5727 64.4904 58.3536 65.1781 58.6769L65.6701 58.9082C68.0718 60.0374 70.6208 60.811 73.2391 61.2054C74.3315 61.3699 75.1425 62.322 75.1425 63.4429V69.413C75.1425 70.6621 74.1424 71.6746 72.9117 71.6746L72.9086 71.6747Z",
    fill: "#95A8AB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.3578 70.8582C56.346 70.8856 41.9172 56.0659 41.9375 36.9392C41.9375 35.6901 42.9352 34.6719 44.1659 34.6719H50.0474C51.1518 34.6719 52.0899 35.4954 52.2521 36.6041C52.6407 39.2612 53.403 41.848 54.5156 44.2855L54.7446 44.7871C55.063 45.4846 54.8472 46.3134 54.2308 46.7601C52.4094 48.0803 51.7133 50.7376 53.1323 52.8111C54.9129 55.4131 57.1575 57.6907 59.7207 59.4972C61.7635 60.9369 64.3814 60.2305 65.6821 58.3822C66.1226 57.7563 66.9396 57.5372 67.6273 57.8605L68.1193 58.0918C70.521 59.221 73.07 59.9946 75.6883 60.389C76.7807 60.5535 77.5918 61.5056 77.5918 62.6265V68.5966C77.5918 69.8457 76.5917 70.8582 75.3609 70.8582L75.3578 70.8582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2247 103.219L24.1562 102.88L27.5466 85.25L31.6151 85.589L28.2247 103.219Z",
    fill: "#9CA3AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2227 103.22L32.2911 82.1992L48.2259 94.4046L28.2227 103.22Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6213_23132",
    x: 0,
    y: 0,
    width: 114.082,
    height: 122.219,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6213_23132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6213_23132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_6213_23132",
    x: 6.07031,
    y: 11,
    width: 93.0117,
    height: 99.1172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -15,
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6213_23132"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_6213_23132",
    result: "effect2_innerShadow_6213_23132"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6213_23132",
    x: 28.4883,
    y: 28.4883,
    width: 57.6523,
    height: 58.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6213_23132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6213_23132",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/WhatsappIcon.86d96fb312a10aad3d138dea6efb0449.svg";
export { ForwardRef as ReactComponent };